import { z } from "zod";

export const schema = z
    .object({
        password: z.string().min(1, "forms.general-validation.password_required"),
        password_confirmation: z.string().min(1, "forms.general-validation.password_confirmation_required"),
    })
    .refine((data) => data.password === data.password_confirmation, {
        message: "forms.general-validation.passwords_dont_match",
        path: ["password_confirmation"],
    });

export type ChangePasswordFormData = z.infer<typeof schema>;
